import { useEffect, useState } from 'react';
import { getAssetData } from '@sovryn/contracts';
import { RSK_CHAIN_ID } from '../config/chains';
import { useIsMounted } from './useIsMounted';
export const useTokenDetailsByAsset = (asset, chainId = RSK_CHAIN_ID) => {
    const isMounted = useIsMounted();
    const [token, setToken] = useState();
    useEffect(() => {
        if (asset && isMounted()) {
            getAssetData(asset, chainId)
                .then(setToken)
                .catch(e => {
                console.error('token not found?', asset, chainId, e);
            });
        }
    }, [asset, chainId, isMounted]);
    return token;
};
